import config from '@feature-config/core/overview/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { OverviewFeature } from './OverviewFeature';

const overviewFeature: FeatureModule = createFeatureModule(
  config,
  OverviewFeature,
  'core/overview'
);

export default overviewFeature;
